import decompress from 'brotli/decompress';

export default function decryptKey(encodedString) {
  // Convert the hex key to a 32-byte Uint8Array using SHA-256
  try {
    const base64String = encodedString?.replace(/^encoded:/, '');

    // Step 2: Decode Base64
    const compressedData = Uint8Array.from(atob(base64String), c => c.charCodeAt(0));

    // Step 3: Decompress using Brotli
    const decompressedData = new TextDecoder().decode(
      decompress(compressedData)
    );

    return decompressedData;
  } catch (error) {
    return '';
  }
}